import React from "react";
import Switch from "@mui/material/Switch";

const CustomSwitch = ({
  checked,
  onChange,
  ariaLabel = "controlled",
  disabled,
}) => {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      inputProps={{ "aria-label": ariaLabel }}
      disabled={disabled}
    />
  );
};

export default CustomSwitch;
